
    // IMPORTS
    import { computed, defineComponent, PropType } from 'vue'
    import { buildLocalization } from '@/util'


    export default defineComponent({
        name: 'boolField',

        props: {
            value: { type: Boolean as PropType<boolean>, required: false },
            format: { type: String as PropType<'coloredYesNo' | 'yesNo' | 'X'>, required: false, default: () => 'X' },
        },

        setup(props) {
            /********************************************************************************************************************
             INIT
             ********************************************************************************************************************/
            const { localize } = buildLocalization()

            /********************************************************************************************************************
             PUBLIC DATA
             ********************************************************************************************************************/
            const publicData = { }

            /********************************************************************************************************************
             COMPUTED DATA
             ********************************************************************************************************************/
            const renderValue = computed(() => formatBool(props.value))
            const style = computed(() => getStyle(props.value))
            const computedData = { renderValue, style }

            /********************************************************************************************************************
             PRIVATE METHODS
             ********************************************************************************************************************/
            function formatBool(value?: boolean): string {
                if (value == null) {
                    return ''
                }

                switch (props.format) {
                    case 'coloredYesNo': return value ? localize('yes') : localize('no')
                    case 'yesNo': return value ? localize('yes') : localize('no')
                    case 'X': return value ? 'X' : '-'
                    default: return '<unknown format>'
                }
            }

            function getStyle(value?: boolean): string {
                if (value == null) {
                    return ''
                }

                switch (props.format) {
                    case 'coloredYesNo': return value ?'color: green' : 'color:red'
                    default: return ''
                }
            }

            /********************************************************************************************************************
             PUBLIC METHODS
             ********************************************************************************************************************/
            const publicMethods = { }

            /********************************************************************************************************************
             COMPONENT INTERFACE
             ********************************************************************************************************************/
            return { ...publicData, ...computedData, ...publicMethods }
        }
    });
